import { useQuery } from '@tanstack/react-query'
import { getEligibleLeadShifts } from 'api/shift'
import { QueryFnParams, QueryOptions } from 'queries/types'
import { eligibleLeadShiftsKey } from './keys'

export function useEligibleLeadShifts(
  params: QueryFnParams<typeof getEligibleLeadShifts>[0],
  options: QueryOptions<typeof getEligibleLeadShifts> = {}
) {
  return useQuery({
    ...options,
    queryKey: eligibleLeadShiftsKey(params.shiftId),
    queryFn: ({ signal }) => getEligibleLeadShifts(params, signal),
  })
}
